import React, { useState, useEffect } from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaWhatsapp,
  FaBars,
  FaTimes,
  FaYoutube,
} from "react-icons/fa";
import { MdEmail, MdPhone } from "react-icons/md";
import { Link } from "react-router-dom";
import logo from "../assets/log.jpeg";

const Navbar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  const pkg = { name: "Sample Package" };

  const handleMouseEnter = (e) => {
    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.12)";
    e.target.style.transform = "translateY(-2px)";
    e.target.style.borderColor = "rgba(255, 255, 255, 0.3)";
    e.target.style.boxShadow = "0 8px 25px rgba(0, 0, 0, 0.3)";
  };

  const handleMouseLeave = (e) => {
    e.target.style.backgroundColor = "rgba(255, 255, 255, 0.05)";
    e.target.style.transform = "translateY(0)";
    e.target.style.borderColor = "rgba(255, 255, 255, 0.1)";
    e.target.style.boxShadow = "0 4px 15px rgba(0, 0, 0, 0.2)";
  };

  return (
    <div>
      {/* Top Navbar */}
      <div style={styles.topBar}>
        <div style={styles.contactInfo}>
          <div style={styles.contactItem}>
            <MdEmail size={15} color="rgba(255, 255, 255, 0.5)" />
            <span>wangotrailsafaris@gmail.com</span>
          </div>
          <div style={styles.contactItem}>
            <MdPhone size={15} color="rgba(255, 255, 255, 0.5)" />
            <span>+254 706 019 613</span>
          </div>
        </div>
        <div style={styles.socialIcons}>
          <FaFacebookF size={14} style={styles.icon} />
          <FaTwitter size={14} style={styles.icon} />
          <FaInstagram size={14} style={styles.icon} />
          <FaYoutube size={14} style={styles.icon} />
          <FaWhatsapp size={14} style={{...styles.icon, color: "#25D366"}} />
        </div>
      </div>

      {/* Main Navbar */}
      <nav style={styles.navbar}>
        <Link to="/" style={styles.logoLink}>
          <img src={logo} alt="WangoTrailSafaris" style={styles.logoImage} />
          <div style={styles.brandContainer}>
            <span style={styles.brandName}>WangoTrail</span>
            <span style={styles.brandSub}>Safaris</span>
          </div>
        </Link>

        {isMobile ? (
          <>
            <div onClick={toggleMenu} style={styles.menuIcon}>
              {menuOpen ? <FaTimes size={22} color="#ffffff" /> : <FaBars size={22} color="#ffffff" />}
            </div>
            {menuOpen && (
              <ul style={{ ...styles.navLinksMobile }}>
                {navItems.map((item) => (
                  <li key={item.to} style={styles.navItem}>
                    <Link to={item.to} style={styles.navLink} onClick={() => setMenuOpen(false)}>
                      {item.label}
                    </Link>
                  </li>
                ))}
                <li style={styles.navItem}>
                  <a
                    href={`https://mail.google.com/mail/?view=cm&fs=1&to=wangotrailsafaris@gmail.com&su=Booking%20Inquiry&body=Hi,%0D%0A%0D%0AI%20want%20to%20book%20assist%20me`}
                    style={styles.bookNowButton}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Book Now
                  </a>
                </li>
              </ul>
            )}
          </>
        ) : (
          <ul style={styles.navLinks}>
            {navItems.map((item) => (
              <li key={item.to} style={styles.navItem}>
                <Link to={item.to} style={styles.navLink}>
                  {item.label}
                </Link>
              </li>
            ))}
            <li style={styles.navItem}>
              <a
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=wangotrailsafaris@gmail.com&su=Booking%20Inquiry%20for%20${encodeURIComponent(pkg.name)}&body=Hi,%0D%0A%0D%0AI%20am%20interested%20in%20the%20"${encodeURIComponent(pkg.name)}"%20package...`}
                style={styles.bookNowButton}
                target="_blank"
                rel="noopener noreferrer"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
                Book Now
              </a>
            </li>
          </ul>
        )}
      </nav>
    </div>
  );
};

const navItems = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/destination", label: "Destinations" },
  { to: "/packages", label: "Packages" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

const styles = {
  topBar: {
    backgroundColor: "#060d1a",
    color: "#ffffff",
    padding: "0.4rem 3rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    fontSize: "0.78rem",
    flexWrap: "wrap",
    borderBottom: "1px solid rgba(255, 255, 255, 0.03)",
  },
  contactInfo: {
    display: "flex",
    gap: "2rem",
    alignItems: "center",
    flexWrap: "wrap",
  },
  contactItem: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    color: "rgba(255, 255, 255, 0.5)",
    transition: "all 0.3s ease",
    cursor: "pointer",
  },
  socialIcons: {
    display: "flex",
    gap: "0.8rem",
    alignItems: "center",
  },
  icon: {
    cursor: "pointer",
    transition: "all 0.3s ease",
    color: "rgba(255, 255, 255, 0.4)",
  },
  navbar: {
    backgroundColor: "#0a1628",
    padding: "0.5rem 3rem",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    position: "relative",
    boxShadow: "0 2px 30px rgba(0, 0, 0, 0.3)",
    borderBottom: "1px solid rgba(255, 255, 255, 0.03)",
  },
  logoLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    gap: "15px",
  },
  logoImage: {
    height: "55px",
    width: "auto",
    objectFit: "contain",
    maxHeight: "65px",
    padding: "2px 0",
    borderRadius: "8px",
    border: "1px solid rgba(255, 255, 255, 0.04)",
    transition: "all 0.3s ease",
  },
  brandContainer: {
    display: "flex",
    flexDirection: "column",
    lineHeight: "1.2",
  },
  brandName: {
    color: "#ffffff",
    fontSize: "22px",
    fontWeight: "bold",
    letterSpacing: "3px",
    fontFamily: "'Georgia', serif",
    textShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
    background: "linear-gradient(135deg, #ffffff 0%, rgba(255,255,255,0.7) 100%)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
  },
  brandSub: {
    color: "rgba(255, 255, 255, 0.4)",
    fontSize: "10px",
    letterSpacing: "6px",
    textTransform: "uppercase",
    fontWeight: "300",
    marginTop: "1px",
  },
  navLinks: {
    listStyle: "none",
    display: "flex",
    gap: "2rem",
    margin: 0,
    padding: 0,
    alignItems: "center",
  },
  navLinksMobile: {
    listStyle: "none",
    display: "flex",
    flexDirection: "column",
    gap: "0.8rem",
    marginTop: "1rem",
    backgroundColor: "#0a1628",
    padding: "1.5rem",
    borderRadius: "12px",
    width: "100%",
    boxShadow: "0 8px 30px rgba(0,0,0,0.5)",
    border: "1px solid rgba(255, 255, 255, 0.05)",
  },
  navItem: {
    cursor: "pointer",
    transition: "all 0.3s",
    display: "flex",
    alignItems: "center",
  },
  bookNowButton: {
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    color: "#ffffff",
    padding: "10px 30px",
    fontSize: "0.85rem",
    borderRadius: "30px",
    textDecoration: "none",
    display: "inline-block",
    transition: "all 0.3s ease",
    fontWeight: "600",
    boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    alignSelf: "center",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  },
  navLink: {
    textDecoration: "none",
    color: "rgba(255, 255, 255, 0.6)",
    transition: "all 0.3s ease",
    fontWeight: "400",
    fontSize: "0.9rem",
    padding: "0.5rem 0",
    borderBottom: "2px solid transparent",
    letterSpacing: "0.5px",
    position: "relative",
  },
  menuIcon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    padding: "8px",
    borderRadius: "8px",
    transition: "all 0.3s ease",
  },
};

// Add hover effects
const styleSheet = document.createElement("style");
styleSheet.textContent = `
  /* Nav link hover */
  .nav-link {
    position: relative;
  }
  
  .nav-link::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 2px;
    background: rgba(255, 255, 255, 0.3);
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }
  
  .nav-link:hover {
    color: #ffffff !important;
  }
  
  .nav-link:hover::after {
    width: 100%;
  }
  
  /* Social icons hover */
  .social-icon:hover {
    color: #ffffff !important;
    transform: translateY(-3px) scale(1.15);
  }
  
  /* Contact items hover */
  .contact-item:hover {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  
  .contact-item:hover svg {
    color: rgba(255, 255, 255, 0.8) !important;
  }
  
  /* Menu icon hover */
  .menu-icon:hover {
    background: rgba(255, 255, 255, 0.05);
  }
  
  /* Logo hover */
  .logo-image:hover {
    transform: scale(1.02);
    border-color: rgba(255, 255, 255, 0.1);
  }
  
  /* Brand name hover */
  .brand-name:hover {
    opacity: 0.8;
  }
  
  /* Mobile nav items */
  .nav-item-mobile:hover {
    background: rgba(255, 255, 255, 0.03);
    border-radius: 8px;
  }
`;
document.head.appendChild(styleSheet);

export default Navbar;